import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const LaosFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15358'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15358)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 10.2666H20V3.73328H0V10.2666Z'
					fill='#073A88'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 3.73333H20V0H0V3.73333Z'
					fill='#E2273E'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14.0001H20V10.2667H0V14.0001Z'
					fill='#E2273E'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.0001 9.33329C11.3151 9.33329 12.381 8.28862 12.381 6.99996C12.381 5.71129 11.3151 4.66663 10.0001 4.66663C8.68513 4.66663 7.61914 5.71129 7.61914 6.99996C7.61914 8.28862 8.68513 9.33329 10.0001 9.33329Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default LaosFlagIcon;
